import React, { createRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import * as R from "ramda";
import { Document, Page, pdfjs } from 'react-pdf';
import { getLetterInformationByLetterId } from '../../../actions/facilita-api';
import { FrenchTypes, PensionProfessionalCategoryMapping } from '../../../constants/utils/connectionTypes';
import * as urls from '../../../constants/webapi/facilita';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export const PreviewDoc = ({ setSelectedUserLetter, serviceDataLetters, documentUrl, selectedServices, serviceLetter, setServiceLetter, setSelectedUserService, selectedUserService, selectedUserLetter }) => {
    const hideModal = () => {
        $('.modal').modal("hide");
    };



    const [numPages, setNumPages] = useState(0);
    const [elementOnFocus, setElementOnFocus] = useState(0);
    const [elRefs, setElRefs] = useState([]);
    const [allLetterToDisplay, setAllLetterToDisplay] = useState([]);

    // useEffect(() => {
    //     // setServiceLetter(lettersOfChosenService);
    //     // setServiceLetter()

    //     if (!R.isNil(selectedServices)) {

    //         let lettersOfChosenService = serviceDataLetters.filter(srvData => srvData.userServiceId === selectedUserService.id);

    //         let promises = [];
    //         lettersOfChosenService.forEach((l) => {
    //             promises.push(getLetterInformationByLetterId(l.letterId));
    //         });

    //         Promise.all(promises)
    //             .then((letters) => {

    //                 lettersOfChosenService = lettersOfChosenService.map(letterService => {
    //                     let letter = letters.find(l => letterService.letterId === l.id);
    //                     if (!R.isNil(letter)) {
    //                         letterService.name = letter.name;
    //                     }
    //                     return letterService;
    //                 });

    //                 setServiceLetter(lettersOfChosenService);
    //                 setSelectedUserLetter(lettersOfChosenService[0]);
    //             });


    //         setElRefs(elRefs => (
    //             selectedServices.map((_, i) => createRef())
    //         ));

    //     }

    // }, [selectedUserService, selectedServices]);

    useEffect(() => {
        // setServiceLetter(lettersOfChosenService);
        // setServiceLetter()

        if (!R.isNil(selectedServices)) {

            let lettersOfChosenService = serviceDataLetters.filter(srvData => srvData.userServiceId === selectedUserService.id);

            let allLetters = [];
            lettersOfChosenService.forEach(l => {
                allLetters.push({
                    url: urls.letterContentUrlByletterId(l.id),
                    httpHeaders: {
                        "Authorization": "Bearer " + localStorage.getItem("access_token")
                    }
                });
            });

            setAllLetterToDisplay(allLetters);

            // setDocumentUrl({
            //     url: urls.letterContentUrlByletterId(selectedUserLetter.id),
            //     httpHeaders: {
            //         "Authorization": "Bearer " + localStorage.getItem("access_token")
            //     }
            // });

            setElRefs(elRefs => (
                selectedServices.map((_, i) => createRef())
            ));

        }

    }, [selectedUserService, selectedServices]);


    function renderDocs() {

    }

    return (
        <div className="modal fade px-0" id="previewDoc" aria-labelledby="previewDoclLabel" aria-hidden="true">
            <div className="modal-dialog px-2 modal-dialog-scrollable container-wide">
                <div className="modal-content bg-light">
                    <div className="modal-header pb-0">
                        <div className="alert bg-common rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
                            <div className="flex-row align-items-center justify-content-between">
                                <div className="h4 text-primary text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="previewDoclLabel">Validation</div>
                                <button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
                                    <i className="eva eva-close fs-4"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="modal-body scroll-default pt-0">

                        <div className="flex-row align-items-center sticky-auto t-auto-0 z-2 bg-light py-3">
                            {/* {!R.isNil(service.serviceDatas) && service.serviceDatas.length > 1 && (elementOnFocus > 0) ? */}
                            {!R.isNil(selectedServices) && selectedServices.length > 1 && (elementOnFocus > 0) ?
                                <button className="btn btn-icon btn-faded btn-square o-50 o-100--hover mr-2 d-none d-xl-unset" onClick={() => {
                                    let elemenetToFocus = elementOnFocus;
                                    if (elementOnFocus > 0) {
                                        elemenetToFocus = elementOnFocus - 1;
                                    }
                                    if (!R.isNil(elRefs[elemenetToFocus]) && !R.isNil(elRefs[elemenetToFocus].current)) {
                                        elRefs[elemenetToFocus].current.scrollIntoView({ behavior: 'smooth' });
                                        elRefs[elemenetToFocus].current.click();
                                    }
                                    setElementOnFocus(elemenetToFocus);
                                }}><i className="eva eva-arrow-ios-back-outline align-middle h4 lh-solid m-auto"></i></button>
                                : ''
                            }
                            <div className="scroller-nav sticky-top bg-light">
                                <nav className="nav py-2 flex-row align-items-center">
                                    {/* {
                                        //userLetters.map((letter, i) => (<div className="img-fluid img-contain" key={i} style={{ width: "100px", height: "100px", cursor: "pointer" }} alt="pdf preview" onClick={() => setSelectedUserLetter(letter)} >letter{i}</div>))
                                        selectedServices && selectedServices.map((service, index) => <button className={"btn btn-outline-primary rounded-max py-2 px-sm mr-1" + (selectedUserService.id === service.id ? " active" : " ")} key={index} ref={elRefs[index]} onClick={() => {

                                            const lettersOfChosenService = serviceDataLetters.filter(srvData => srvData.userServiceId === service.id);
                                            //setServiceLetter(lettersOfChosenService);
                                            setElementOnFocus(selectedServices.indexOf(service));
                                            setSelectedUserService(service);

                                        }} >{service.serviceName}</button>)
                                    } */}

                                    {

                                        selectedServices && selectedServices.map((service, index) => {
                                            let name = service.serviceName;
                                            if (service.serviceType === FrenchTypes.activity) {
                                                name = service.payload.companyName;
                                            } else if (service.serviceType === FrenchTypes.otherActivity) {
                                                name = service.payload.name;
                                            } else if (service.serviceType === FrenchTypes.pension) {
                                                let categories = Object.values(PensionProfessionalCategoryMapping[0].options).concat(
                                                    Object.values(PensionProfessionalCategoryMapping[1].options)
                                                ).concat(
                                                    Object.values(PensionProfessionalCategoryMapping[2].options)
                                                ).concat(
                                                    Object.values(PensionProfessionalCategoryMapping[3].options)
                                                );
                                                name = categories.find(c => c.value === service.payload.professionalCategory).title;
                                            } else if (service.serviceType === FrenchTypes.socialSecurity) {
                                                name = "CPAM";
                                            }

                                            if (service.serviceId.startsWith('Custom')) {
                                                name = service.customServiceDetails.name;
                                            }

                                            return (<button className={"btn btn-outline-primary rounded-max py-2 px-sm mr-1" + (selectedUserService.id === service.id ? " active" : "")} key={"service_" + index} ref={elRefs[index]} onClick={() => {
                                                //const lettersOfChosenService = serviceDataLetters.filter(srvData => srvData.userServiceId === service.id);
                                                //setServiceLetter(lettersOfChosenService);
                                                setElementOnFocus(selectedServices.indexOf(service));
                                                setSelectedUserService(service);
                                            }}>{name}</button>);
                                        })
                                    }
                                </nav>
                            </div>
                            {/* {
                                serviceLetter.map((sl, index) => (<button key={index} onClick={() => setSelectedUserLetter(sl)}>letter{index}</button>))
                            } */}
                            {/* {!R.isNil(service.serviceDatas) && service.serviceDatas.length > 1 ? */}
                            {!R.isNil(selectedServices) && selectedServices.length > 1 && elementOnFocus < selectedServices.length - 1 ?
                                <button className={"btn btn-icon btn-faded btn-square o-50 o-100--hover ml-2"} onClick={() => {
                                    let elemenetToFocus = elementOnFocus;
                                    if (elementOnFocus < selectedServices.length - 1) {
                                        elemenetToFocus = elemenetToFocus + 1;
                                    }
                                    if (!R.isNil(elRefs[elemenetToFocus]) && !R.isNil(elRefs[elemenetToFocus].current)) {
                                        elRefs[elemenetToFocus].current.scrollIntoView({ behavior: 'smooth' });
                                        elRefs[elemenetToFocus].current.click();
                                    }
                                    setElementOnFocus(elemenetToFocus);

                                }}><i className="eva eva-arrow-ios-forward-outline align-middle h4 lh-solid m-auto"></i></button>
                                : ''
                            }
                        </div>

                        <div className="block mx-auto container-lg-copy">
                            {


                                !R.isEmpty(allLetterToDisplay) && allLetterToDisplay.map((docUrl, index) => (

                                    <Document className="border-0 h-wide" file={docUrl} loading={"Chargement..."} key={index}
                                        onLoadSuccess={({ numPages }) => setNumPages(numPages)}>
                                        {Array.apply(null, Array(numPages))
                                            .map((x, i) => i + 1)
                                            .map(page => <Page pageNumber={page} width={500} loading={"Chargement..."} key={"pdfviewer_page_" + page} className={"card paper-shadow mb-2 mx-auto align-items-center"} />)}
                                    </Document>


                                ))


                            }



                        </div>

                        {/* <div className="position-relative w-100">
                                <div className="modal-body scroll-default py-2 px-2 position-fixed f-flex flex-column ">
                                    {serviceLetter.map((sl, index) => (<button type="button" className={"btn btn-outline-primary rounded-max py-2 px-sm mr-1 my-1" + (sl.letterId === selectedUserLetter?.letterId ? " active" : " ")} key={index} title={sl.name.toString()} onClick={() => setSelectedUserLetter(sl)}> <span className="d-inline-block text-truncate" style={{ maxWidth: "100px" }}>{sl.name}</span></button>))}
                                </div>
                            </div> */}


                    </div>

                </div>
            </div>
        </div>
    );
};